<template>
  <span :class="span_class"> {{status}} </span>
</template>
<script>
export default {
  name: "ItemStatus",
  props: ["status", "span_class"],
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/orders/datatable_custom_cells/ItemStatus.vue